import { Stack } from "@mantine/core";
import { HeldEmailDetail } from "../../../services/admin/systemEmails.service";
import { SystemEmailPreviewFrame } from "./SystemEmailPreviewFrame";
import { HeldEmailDetailMetadata } from "./HeldEmailDetailMetadata";

interface HeldEmailDetailContentProps {
  detail: HeldEmailDetail;
  waitingTime: string;
}

export function HeldEmailDetailContent({
  detail,
  waitingTime,
}: HeldEmailDetailContentProps) {
  return (
    <Stack gap="sm">
      <HeldEmailDetailMetadata detail={detail} waitingTime={waitingTime} />
      <SystemEmailPreviewFrame html={detail.bodyHtml} title={detail.subject} />
    </Stack>
  );
}
